import CTAButton from "../../atoms/CTAButton/CTAButton";
import { CustomContainer } from "../../atoms/DependencyHelper";
import styles from "./InfoWithButton.module.scss";

const InfoWithButton = ({ title, description, buttonText, buttonHandler, containerClass }) => {
    const handleClick = (e) => {
        e.preventDefault();
        buttonHandler(buttonText)
    }
    return (
        <CustomContainer className={`${styles["container"]} ${containerClass}`}>
            <p className={styles["title"]}>{title}</p>
            <p className={styles["description"]}>{description}</p>
            <CTAButton
                variant="link black"
                className={styles["button"]}
                handleClick={e => handleClick(e)}
            >
                {buttonText}
            </CTAButton>
        </CustomContainer>
    )
}
export default InfoWithButton;